module.exports = __webpack_public_path__ + "img/2.eba35cb.svg";